import { Endpoint } from '../endpoint';
import { UserId } from '@business/entities/account';
import { R } from '@core/utils/r';
import { NoteId, NoteResponse, NoteSearchParams } from '@business/entities/note';

export function fetchNotes(params?: NoteSearchParams) {
  return Endpoint.get<NoteResponse[]>('@makh/notes', { params: R.objectCompact(params) });
}

export function fetchNote(id: NoteId) {
  return Endpoint.get<NoteResponse>(`@makh/notes/note/${id}`);
}

export function createNote(payload: Partial<NoteResponse>, userId?: UserId) {
  const data = R.objectCompact({ ...payload, userId: userId });
  return Endpoint.post<NoteResponse>(`@makh/notes`, { data });
}

export function updateNote(id: NoteId, data: Partial<NoteResponse>) {
  return Endpoint.patch<NoteResponse>(`@makh/notes/${id}`, { data });
}

export function deleteNote(id: NoteId) {
  return Endpoint.delete<void>(`@makh/notes/${id}`);
}
